const SvgMiddleware1 = (props) => (
  <>
    <circle cx={160} cy={160} r={16} fill={props.p20} />
    <circle cx={96} cy={32} r={16} fill={props.p20} />
    <circle cx={96} cy={160} r={16} fill={props.p20} />
    <circle cx={32} cy={160} r={16} transform="rotate(-45 32.002 159.994)" fill={props.p20} />
    <circle cx={64.18} cy={95.63} r={16} fill={props.p20} />
    <circle cx={128} cy={96} r={16} fill={props.p20} />
  </>
);

export default SvgMiddleware1;
